import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var orderBookConfigURL = function (user) {
    return {
        eqOrderBook: config.jmw +
            config.kambalaBase +
            config.equity +
            "order/book/" +
            user +
            "/v1",
        mfOrderBook: config.jmw + config.kambalaBase + config.jmw_mf + "order/" + user,
        mfOrderBookHolding: config.jmw + config.kambalaBase + config.jmw_mf + "order/hold/" + user,
        eqSipOrderBook: config.jmw + config.jmw_eq + "order/sip/v1/" + user,
        mfSipOrderBook: config.jmw + config.jmw_mf + "order/sip/" + user,
        mfSipChildOrderBook: config.jmw + config.jmw_mf + "order/sip/" + user + "/child",
        mfOrderBookCancel: config.jmw + config.jmw_mf + "trade/" + user,
        snapQoute: config.jmw + config.jmw_eq + "/order/snapquote/" + user,
        coOrderBook: config.jmw + config.commodity + "orderbook/" + user,
        nfoOrderBook: config.jmw + config.kambalaBase + config.jmw_mf + "order/nfo/" + user,
        nfoOrderBookCancel: config.jmw + config.jmw_mf + "trade/" + user,
        ipoOrderBook: config.jmw + config.edelmw_nse + "ipo/orderstatus",
        ofsOrderbook: config.jmw + config.jmw_eq + "ofs/orderbook/" + user,
        ofsCancelOrder: config.jmw + config.jmw_eq + "ofs/canceltrade/" + user,
    };
};
export default orderBookConfigURL;
